export default __webpack_public_path__ + "static/media/skovstykket-townhouse-5-rooms-11.ffb7e557.jpg";